import React from "react";
import {
  Table,
} from "reactstrap";
import moment from 'moment';
import GuestReportModel from "../../../../utils/models/GuestReportModel";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

export default function GuestsList({
  guestsList = [],
  loading = false,
}) {
  return (
    <div style={{ paddingBottom: '10px' }}>
      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Stand</th>
              <th>Email Participante</th>
              <th>Nome Participante</th>
              <th>Quem Coletou?</th>
              <th>Quando Coletou?</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <LoadingSkelentonTable lines={10} cols={5} />
            ) : (
              guestsList.map((s, i) => renderRow(i, s))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )

  function renderRow(index = 0, guest = GuestReportModel()) {
    return (
      <tr key={index}>
        <td>{guest.organization}</td>
        <td>{guest.guestEmail}</td>
        <td>{guest.guestName}</td>
        <td>{guest.userName}</td>
        <td>{moment(guest.date).format('DD/MM/YYYY HH:mm')}</td>
      </tr>
    )
  }
}
